module.exports = __webpack_public_path__ + "media/images/redrock/stone_back-7dfc3f23ddca9a2078bb11fbdb1d0950.jpg";